import React from "react";
import { AdminAction, AdminActionGroup } from "../admin";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("UI render error:", error, errorInfo);
  }

  render() {
    if (!this.state.error) return this.props.children;

    if (this.props.fallback !== undefined) return this.props.fallback;

    const message =
      this.state.error?.message ||
      "Something went wrong while rendering this page.";

    return (
      <div className="min-h-screen bg-[#f0f2ee] p-6 text-[#172112]">
        <div className="mx-auto max-w-2xl rounded-xl border border-red-200 bg-white p-6 shadow-sm">
          <p className="text-xs font-bold uppercase tracking-[0.12em] text-red-600">
            Page error
          </p>
          <h1 className="mt-2 text-2xl font-semibold">This screen could not load</h1>
          <p className="mt-3 text-sm text-stone-600">
            The app caught the error instead of showing a blank page.
          </p>
          <pre className="mt-4 max-h-52 overflow-auto rounded-lg bg-red-50 p-4 text-sm text-red-800">
            {message}
          </pre>
          <AdminActionGroup align="start">
            <AdminAction
              type="button"
              onClick={() => window.location.reload()}
            >
              Reload
            </AdminAction>
            <AdminAction
              type="button"
              variant="ghost"
              onClick={() => {
                this.setState({ error: null });
                window.history.back();
              }}
            >
              Go back
            </AdminAction>
          </AdminActionGroup>
        </div>
      </div>
    );
  }
}
